import { SettingsApiTypes } from "@rshbintech.dboul/http";
import { getMenuItemsSettings } from "../../utils";
import { MenuConfig, MenuItem } from "../types";
import { ClientSettings, ConstructorParams } from "./types";

export class MenuItemsService {
  public menuConfig: MenuConfig;

  constructor({ defaultMenuConfig }: ConstructorParams) {
    this.menuConfig = defaultMenuConfig;
  }

  public disableByClientSettings(clientSettings: ClientSettings) {
    // INFO: Проверяем наличие настроек отображения пунктов меню из МС Настройки
    if (!clientSettings?.settings?.frontend) {
      return this;
    }

    const menuItemsSettings = getMenuItemsSettings(clientSettings);

    // INFO: Проверяем значения пунктов меню пришедших из МС Настройки с конфигурацией по умолчанию из DEFAULT_MENU_CONFIG
    Object.values(this.menuConfig).forEach((menuSection) => {
      menuSection.forEach((menuItem) => {
        // Если пункт меню не доступен, дополнительных проверок не проводим.

        const checkMenuItem = (
          menuItemsSettings: SettingsApiTypes.SettingsItem[],
          menuItem: MenuItem
        ) => {
          if (menuItem.disabled) {
            return;
          }

          const menuItemSetting = menuItemsSettings.find(
            (menuItemSetting) => menuItemSetting.key === menuItem.path
          );

          if (menuItemSetting === undefined) {
            return;
          }

          menuItem.disabled = menuItemSetting.value === "false";
        };

        const { additionalItems } = menuItem;

        //INFO: Проверка для вложенных пунктов меню
        if (additionalItems?.length) {
          additionalItems.forEach((additionalItem) =>
            checkMenuItem(menuItemsSettings, additionalItem)
          );
        }

        checkMenuItem(menuItemsSettings, menuItem);
      });
    });

    return this;
  }

  public disableByAvailabilityForUser(
    checkAvailableFunction: (path: string) => boolean
  ) {
    Object.values(this.menuConfig).forEach((menuSection) => {
      menuSection.forEach((menuItem) => {
        // Если пункт меню не доступен, дополнительных проверок не проводим.
        if (menuItem.disabled) {
          return;
        }

        const { additionalItems } = menuItem;

        //INFO: Проверка для вложенных пунктов меню
        if (additionalItems?.length) {
          additionalItems.forEach(
            (additionalItem) =>
              (additionalItem.disabled =
                additionalItem.disabled ||
                !checkAvailableFunction(additionalItem.path))
          );
        }

        menuItem.disabled = !checkAvailableFunction(menuItem.path);
      });
    });

    return this;
  }
}
